@if (showFilters || allowNewCommunication()) {
	<section>
		@if (allowNewCommunication()) {
			@if (allowNewMail) {
				<button add circle (click)="toggleAddMail()" [selected]="showSendMail" [loader]="false"><icon type="envelope" /></button>
			}
			@if (allowNewComment) {
				<button add circle (click)="toggleAddComment()" [selected]="showAddComment" [loader]="false"><icon type="comment" /></button>
			}
		}
		@if (showFilters) {
			@if (allowNewCommunication()){
				<hr [attr.text]="'general.filter' | translate" right />
			}
			<button circle small ghost [selected]="logFilter.indexOf(logEntryType.Mail) >= 0" (click)="toggleFilter(logEntryType.Mail)" [loader]="false"><icon type="envelope" family="solid" /></button>
			<button circle small ghost [selected]="logFilter.indexOf(logEntryType.Internal) >= 0" (click)="toggleFilter(logEntryType.Internal)" [loader]="false"><icon type="comment" family="solid" /></button>
			<button circle small ghost [selected]="logFilter.indexOf(logEntryType.Event) >= 0" (click)="toggleFilter(logEntryType.Event)" [loader]="false"><icon type="list-check" family="solid" /></button>
		}
	</section>
}

@if (showAddComment) {
	<task-action-comment (onSave)="saveComment($event)" (onCancel)="toggleAddComment()" />
}
@if (showSendMail) {
	<task-action-mail [contacts]="contacts" [taskAction]="taskAction" (onSave)="sendNewMail($event)" (onCancel)="toggleAddMail()" />
}
<scrollable>
	@if (loading) {
		<skeletons [defaultSkeletons]="2" />
	}
	<communication-log [communicationLog]="filteredLogEntries" [sendMailFunction]="sendReplyMail" />
</scrollable>
